/**
 * Deposits — 25/02/2026
 *
 * Página dedicada ao painel de Cauções (antigo "Cauções — Painel DAF"),
 * agora disponível a TODOS os utilizadores autenticados. Antes só
 * aparecia como widget no Dashboard e só admins/gestores/direção/dgo
 * viam. Pedido do utilizador para dar visibilidade cruzada.
 *
 * Composição:
 *  - Cabeçalho da página com contexto
 *  - Widget reutilizável DepositSummaryPanel (mesmos dados do dashboard)
 *  - Callout com nota de responsabilidade / significado do painel
 */

import DepositSummaryPanel from "@/components/DepositSummaryPanel";
import { AlertTriangle, Info } from "lucide-react";

export default function Deposits() {
  return (
    <div className="space-y-6" data-testid="deposits-page">
      <header className="space-y-1">
        <div className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground font-semibold">
          Painel de Cauções
        </div>
        <h1 className="text-2xl font-ui text-foreground">Cauções em curso</h1>
        <p className="text-sm text-muted-foreground max-w-2xl">
          Vista transversal do estado dos pagamentos de caução — quem já pagou o kickstart, quem tem remanescente em falta e o volume total ainda por confirmar antes do arranque do serviço.
        </p>
      </header>

      <DepositSummaryPanel />

      <div
        className="rounded-2xl border border-[hsl(var(--info))]/20 bg-[hsl(var(--info-bg))]/50 px-5 py-4 flex items-start gap-3"
        data-testid="deposits-info-callout"
      >
        <div className="p-1.5 rounded-full bg-[hsl(var(--info))]/15 text-[hsl(var(--info))]">
          <Info className="w-4 h-4" />
        </div>
        <div className="text-xs text-muted-foreground leading-relaxed">
          <div className="text-foreground font-semibold mb-0.5">Como interpretar este painel</div>
          A caução mínima (kickstart) desbloqueia o arranque do recrutamento; a caução total tem de estar liquidada antes do início do serviço. Se algum lead teu aparece aqui em atraso, alinha com o cliente antes de agendar o arranque. Os movimentos financeiros são reconciliados diariamente pela DAF via ficheiros bancários (Millennium, BPI, Santander).
        </div>
      </div>
    </div>
  );
}
